import React from 'react';
import './percent-change-cell-type.scss';
import PercentArrow from '../../../PercentArrow/PercentArrow';

export default ({ value }) => {
    return (
        <PercentArrow label='this week' value={value} />
    );
};
